<template>
    <div>
        <b-skeleton-table
            :rows="8"
            :columns="3"
            :table-props="{ bordered: true, striped: true }"
            v-if="loading"
        ></b-skeleton-table>         
        <div class="mb-5" v-if="periodGoals.minMP && !loading">
			<b-row align-v="start">
				<b-col cols="6" md="3">
					<h3 class="ml-2 mb-3">Итоги месяца</h3>
					<div 
						class="results-column"
						:class="periodGoals.minMP.solved ? 'results-column__success':''"
						style="min-width: auto;"
					>
						<!-- <b>{{ periodGoals.minMP.title }}</b> -->
						<div>
							<span 
								class="bigNumber" 
							>{{ periodGoals.minMP.sum | toShortCurrency }}&nbsp;р.</span>
							<div class="small-label">Точка безубыточности компании</div>
						</div>
						<div>
							<span class="bigNumber">{{ periodGoals.minMP.result | toShortCurrency }}&nbsp;р.</span>
							<div class="small-label">Маржинальная прибыль компании за месяц, без НДС</div>
						</div>
						<div>
							<span class="bigNumber">{{ bonusPartSum.sum | toShortCurrency }}&nbsp;р.</span>
							<div class="small-label">Бонусная часть к выплате по компании</div>
						</div>
						<div>
							<span class="bigNumber">{{ bonusPartSum.sumWithFee | toCurrency }}&nbsp;р.</span>
							<div class="small-label">Бонусная часть с учетом налога</div>
						</div>
						<!-- <div>Осталось до достижения результата: <span class="bigNumber">{{ periodGoals.minMP.full_debt | toCurrency }}</span>&nbsp;р.</div> -->
					</div>					
				</b-col>
				<b-col cols="12" md="9">
					<h3 class="ml-2 mb-3">Статистика за полгода</h3>
					<div class="results-on-chart">
						<DepartmentResultsChart
							:selectedPeriod="selectedPeriod"
						></DepartmentResultsChart>
					</div>						
				</b-col>
			</b-row>			
        </div>
        <div
          v-for="(departament, dep_name) in scoredMotivation"
		  v-if="dep_name != 'Руководство компании'"
          :key="dep_name"
          class="mb-5"
        >
          <template v-if="departament.length > 0">
			<div class="d-flex mb-3" style="align-items: flex-end;">
				<h3 class="ml-2 mb-0 mt-0">{{ dep_name }}</h3>
				<div style="margin-bottom: 2px;">
					<b-button-toolbar key-nav aria-label="Переключатель статистики">
						<b-button-group size="sm" class="ml-4">
							<b-button
								:variant="statTrigger=='mp' ? 'primary':'secondary'"
								@click="statTrigger='mp'"
							>МП</b-button>
							<b-button
								:variant="statTrigger=='orders' ? 'primary':'secondary'"
								@click="statTrigger='orders'"
							>Поставки</b-button>
						</b-button-group>
					</b-button-toolbar>					
				</div>
			</div>
            <div 
				v-if="statTrigger=='orders'"
				class="row mt-3 mb-4" 
				style="align-items: flex-end;"
			>
				<div class="col-md-12">
					<DepartmentOrdersChart
					    :key="`dep-${dep_name}-order-chart`"
						:selectedPeriod="selectedPeriod"
						:depName="dep_name"
					></DepartmentOrdersChart>
				</div>
			</div>
            <div 
				v-if="statTrigger=='mp'"
				class="row mt-3 mb-4" 
				style="align-items: flex-end;"
			>
              <div class="col-md-8 text-center">
                <ColumnChart
					:key="`columnchart-${dep_name}`"
					:height="200"
					:chartData="chartData[dep_name]"
					:options="chartOptions"
                ></ColumnChart>
              </div>
              <div class="col-md-4 text-center">
                <vue-speedometer
					:key="`speedometer-${dep_name}`"
					:width="400"
					:height="230"
					:value="toShortMillions(departament[0].parameters[0].mpd)"
					needleColor="steelblue"
					:needleTransitionDuration="4000"
					needleTransition="easeElastic"
					currentValueText="МП отдела: ${value} млн"
					textColor="${textColor}"
					:customSegmentStops="departamentSegmentStops[dep_name]"
					:minValue="departamentSegmentStops[dep_name][0]"
					:maxValue="departamentSegmentStops[dep_name][departamentSegmentStops[dep_name].length - 1]"
					:segmentColors='["#E57A27", "#FFD700", "#90EE90", "#0F6348"]'
                />
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-hover table-bordered">
                <!-- <tr>
                  <th class="bg-green-light" v-if="dep_name == 'Руководство компании'" style="width: 250px;">100% KPI</th>
                  <th class="bg-green-light" v-if="dep_name != 'Руководство компании'" style="width: 250px;">100% KPI Отдела</th>
                  <td class="bg-gray-light" :colspan="departament.length + 1">{{ departament[0].parameters[0].kpi.value | toCurrency }}&nbsp;р.</td>
                </tr> -->
                <tr>
                    <th 
						class="bg-green-light" 
						style="width: 210px;"
						v-if="dep_name == 'Руководство компании'"
					>Маржинальная прибыль</th>
                    <th 
						class="bg-green-light" 
						style="width: 210px;"
						v-if="dep_name != 'Руководство компании'"
					>Маржинальная прибыль отдела</th>
                    <td class="bg-gray-light" :colspan="departament.length + 1">{{ departament[0].parameters[0].mpd | toShortCurrency }}&nbsp;р.</td>
                </tr>
                <tr>
                  <th class="bg-green-light">Имя сотрудника</th>
                  <td
                    :class="user.user.fired==1 ? 'bg-danger-light':'bg-green-light'"
                    v-for="(user, user_index) in departament"
                    :key="user_index"
                  >
                    {{ user.user.name }}
                  </td>
                  <td><b>Сумма</b></td>
                </tr>
                <tr>
                  <th class="bg-green-light">Личная маржинальная прибыль</th>
                  <td
                    class="bg-gray-light"
                    v-for="(user, user_index) in departament"
                    :key="user_index"
                  >
                    <template v-if="user.parameters[0].mpp != 0">
                      <span class="cursor-pointer link-underline" @click="showMotivationByUserId(user.parameters[0].finance_ids, user.user.user_ids)">{{ user.parameters[0].mpp | toShortCurrency }}&nbsp;р.</span>
                    </template>
                    <template v-else>
                      0 р.
                    </template>
                  </td>
                  <td style="white-space: nowrap;">{{ sumByRow('mpp', dep_name) }}</td>
                </tr>
                <tr>
                  <th class="bg-green-light">Бонус по результатам отчетного периода</th>
                  <td
                    class="bg-gray-light"
                    v-for="(user, user_index) in departament"
                    :key="user_index"
                  >
                    <div>
						<span :title="`Персональный бонус по KPI - ${user.parameters[0].mpp_perc}%`">{{ user.motivation_bonus | toShortCurrency }}&nbsp;р.</span>
						<br>
						<template v-if="user.parameters[0].is_head == 1">
							<span title="Бонус по KPI за сотрудников отдела">{{ (user.motivation_bonus_for_head ? user.motivation_bonus_for_head : 0) | toShortCurrency }}&nbsp;р.&nbsp;({{ user.parameters[0].mpp_perc_for_head }}%)</span>
						</template>
						<template v-else><br></template>
					</div>
                    <div class="row">
                      <div class="col-md-6 small text-success" title="Бонусы из оценки сотрудника">
                        <template v-if="user.motivation_hand_bonus != 0">
                          <span class="cursor-pointer link-underline" @click="showHandMotivationByUserId(user.user.id)">+{{ user.motivation_hand_bonus | toShortCurrency }}&nbsp;р.</span>
                        </template>
                        <template v-else>
                          0&nbsp;р.
                        </template>
                      </div>
                      <div class="col-md-6 small text-danger" title="Штрафы из оценки сотрудника">
                        <template v-if="user.motivation_hand_fines != 0">
                          <span class="cursor-pointer link-underline" @click="showHandMotivationByUserId(user.user.id)">-{{ user.motivation_hand_fines | toShortCurrency }}&nbsp;р.</span>
                        </template>
                        <template v-else>
                          0&nbsp;р.
                        </template>
                      </div>
                    </div>
                  </td>
                  <td style="white-space: nowrap;">
                    <div title="Бонус по KPI">{{ sumByRow('motivation_bonus', dep_name) }}</div>
                    <div class="row">
                        <div class="col-md-6 small text-success" title="Бонусы из оценки сотрудника">
                            {{ sumByRow('motivation_hand_bonus', dep_name) }}
                        </div>
                        <div class="col-md-6 small text-danger" title="Штрафы из оценки сотрудника">
                            {{ sumByRow('motivation_hand_fines', dep_name) }}
                        </div>
                      </div>
                  </td>
                </tr>
                <tr>
					<th class="bg-green-light">Итоговый бонус по результатам отчетного периода</th>
					<td
					  class="bg-gray-light"
					  v-for="(user, user_index) in departament"
					  :key="user_index"
					>
					  {{ (user.motivation_bonus + (user.motivation_bonus_for_head ? user.motivation_bonus_for_head : 0) + user.motivation_hand_bonus - user.motivation_hand_fines) | toShortCurrency }}&nbsp;р.
					</td>
					<td style="white-space: nowrap;">{{ sumByRow('all', dep_name) }}</td>
				</tr>
				<tr>
					<th class="bg-green-light">Итоговый бонус с учетом налога</th>
					<td
					  class="bg-gray-light"
					  v-for="(user, user_index) in departament"
					  :key="user_index"
					>
					  {{ (user.motivation_bonus + (user.motivation_bonus_for_head ? user.motivation_bonus_for_head : 0) + user.motivation_hand_bonus - user.motivation_hand_fines) / 0.87 | toCurrency }}&nbsp;р.
					</td>
					<td style="white-space: nowrap;">{{ sumByRow('all', dep_name, 0.87) }}</td>
				  </tr>
				</table>
            </div>
          </template>
        </div>
    </div>
</template>

<script>
    import ColumnChart from "@/components/charts/ColumnChart.vue";
    import VueSpeedometer from "vue-speedometer";
    import { toShortMillions } from "@/mixins/textFilters";
    import { mapGetters } from 'vuex';
    import {
        API_GET_MOTIVATION_LOAD_RESULTS
    } from '@/constants';
	import DepartmentResultsChart from "@/components/motivation/DepartmentResultsChart";
	import DepartmentOrdersChart from "@/components/motivation/DepartmentOrdersChart";

    const TO_ROLES = [
        'TO-head-manager',
        'TO-manager'
    ]
    const LOGIST_ROLES = [
        'logistics-head-manager',
        'logistics-manager'
    ]

    export default {
        components: {
            ColumnChart,
            VueSpeedometer,
			DepartmentResultsChart,
			DepartmentOrdersChart
        },
        mixins: [
            toShortMillions
        ],
        props: {
            isUpdating: { type: Boolean, required: false, default: false },             // If we need to update data
            periodRange: { type: Array,
                          required: true,
                          default: function () {
                              return []
                          }
            },                                                                      // list of months
            selectedPeriod: { type: String, required: false, default: null },        // selected month number
            userFilterByOtdel: { type: String, required: false, default: 'all' },      // selected user filter
        },
        data() {
            return {
                loading: true,
				statTrigger: 'mp',
                additionalGetParameter: '',
                componentRefreshKey: 0,
                visibleUsersDataForTable: [],
                visibleFieldsForTable: [],
				bonusPartSum: {
					sum: 0, 
					sumWithFee: 0
				},
                scoredMotivation: [],
                periodGoals: {},
                departamentSegmentStops: {},
                chartData: {},
                chartOptions: {
                    legend: {
                        display: true,
                        position: "bottom",
                        labels: {
                            fontColor: "#000000",
                            boxWidth: 50,
                            fontStyle: "bold",
                            padding: 15,
                            fontSize: 15,
                        },
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                fontStyle: "bold",
                            },
                        }, ],
                        yAxes: [{
                            ticks: {
                                fontStyle: "bold",
                                callback: function(value, index, values) {
                                    return value + ' млн'
                                }
                            },
                        }, ],
                    },
                    plugins: {
                        datalabels: {
                            align: 'center',
                            anchor: 'center',
                            color: "#FFFFFF",
                            font: {
                                weight: "bold",
                                size: 14
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false
                },
            }
        },
        watch: {
            scoredMotivation: {
                handler(scoredMotivation) {
                    this.formTableData()
                },
                deep: true,
            },
            selectedPeriod: {
                handler(value) {
                    this.getScoredMotivation()
                },
            },
            isUpdating: {
                handler(value) {
                    if (value == true) {
                        this.getScoredMotivation()
                    }
                },
            },
            userFilterByOtdel: {
                handler(filterType) {
                    if (this.visibleUsersDataForTable) {
                        this.filteringDataByGroupFilter(filterType)
                    }
                },
            },
        },
        computed: {
            ...mapGetters("auth", ["currentUser"])
        },
        mounted() {
        },
        methods: {
            getScoredMotivation() {
                this.loading = true;
                this.scoredMotivation = [];

                api.call('get', API_GET_MOTIVATION_LOAD_RESULTS + `?date_from=${this.selectedPeriod}`).then((response) => {
                    this.$emit('setData', JSON.parse(JSON.stringify(response.data)))
                    this.scoredMotivation = response.data
                    this.periodGoals = this.scoredMotivation.goals
                    delete this.scoredMotivation.goals
                    this.createChartData()
                    this.createSegmentStops()
					this.calculateBonusPartSum();
                    this.loading = false
                    this.$emit('setMainParameters', this.periodGoals["mainparams"])
                    this.$emit('isUpdating', true)
                })
            },
            filteringDataByGroupFilter(filterType){
                this.formTableData()
                this.visibleUsersDataForTable = this.visibleUsersDataForTable.filter(item => {
                    if (filterType == 'heads') {
                        return (item.user_roles.includes("president"))
                    } else if (filterType == 'sellers') {
                        return (item.user_roles.includes("sales-manager") || item.user_roles.includes("sales-head-manager"))
                    } else if (filterType == 'suppliers') {
                        return (!item.user_roles.includes("sales-manager") && !item.user_roles.includes("sales-head-manager"))
                    } else if (filterType == 'to_department') {
                        return (item.user_roles.includes("TO-manager") || item.user_roles.includes("TO-head-manager"))
                    } else if (filterType == 'ved_department') {
                        return (item.user_roles.includes("logistics-manager") || item.user_roles.includes("logistics-head-manager"))
                    } else {
                        return item
                    }
                })
            },
            createChartData() {
                for (const dep_name in this.scoredMotivation) {
                    let departament = this.scoredMotivation[dep_name]
                    if (departament.length > 0) {
                        this.chartData[dep_name] = {
                            labels: [],
                            datasets: [
                                {
                                    label: dep_name,
                                    backgroundColor: '#E57A27',
                                    data: []
                                }
                            ]
                        }

                        departament.forEach((user, index) => {
                            this.chartData[dep_name].labels.push(user.user.name)
                            this.chartData[dep_name].datasets[0].data.push(this.toShortMillions(user.parameters[0].mpp))
                        })
                    }
                }
            },
            createSegmentStops() {
                for (const dep_name in this.scoredMotivation) {
                    let departament = this.scoredMotivation[dep_name]
                    if (departament.length > 0) {
                        this.departamentSegmentStops[dep_name] = [0]

                        let minSpeedometrSegment = 0;
                        let maxSpeedometrSegment = 0;

                        if (departament[0]) {
                            maxSpeedometrSegment = this.toShortMillions(departament[0].parameters[0].mpa)
                        } 
                        
                        this.departamentSegmentStops[dep_name].push(minSpeedometrSegment)
                        this.departamentSegmentStops[dep_name].push(maxSpeedometrSegment)

                        // Если отдел перевыполнил план - добавить еще цифру в спидометер
                        // let mpd = this.toShortMillions(departament[0].parameters[0].mpd)

                        // if (mpd > this.departamentSegmentStops[dep_name][this.departamentSegmentStops[dep_name].length - 1]) {
                        //     this.departamentSegmentStops[dep_name].push(mpd)
                        // }
                    }
                }
            },
			calculateBonusPartSum() {
                let formatter = new Intl.NumberFormat('ru-RU', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })

				this.bonusPartSum.sum = 0;
				this.bonusPartSum.sumWithFee = 0;

				for(let dep in this.scoredMotivation) {
					this.scoredMotivation[dep].forEach((user) => {
						this.bonusPartSum.sum += user.motivation_bonus ? user.motivation_bonus : 0;
						this.bonusPartSum.sum += user.motivation_bonus_for_head ? user.motivation_bonus_for_head : 0;
						this.bonusPartSum.sum += user.motivation_hand_bonus ? user.motivation_hand_bonus : 0;
						if (user.motivation_hand_fines < 0) {
							this.bonusPartSum.sum += user.motivation_hand_fines;
						} else {
							this.bonusPartSum.sum -= user.motivation_hand_fines;
						}
					})
				}

				this.bonusPartSum.sumWithFee = this.bonusPartSum.sum / 0.87;
			},
            sumByColumn(columnName) {
                let sum = 0
                let formatter = new Intl.NumberFormat('ru-RU', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })

                this.visibleUsersDataForTable.forEach((manager, index) => {
                    sum += manager[columnName]
                })

                switch (columnName) {
                    case 'leads':
                        sum = sum + ' р.'
                        break;
                    default:
                        sum = formatter.format(sum) + ' р.'
                }


                return sum
            },
            sumByRow(columnName, dep_name, nalogK = 1) {
                let sum = 0
                let formatter = new Intl.NumberFormat('ru-RU', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: nalogK == 1 ? 0 : 2
                })

                this.scoredMotivation[dep_name].forEach((manager, index) => {
                    if (columnName === 'motivation_bonus') {
                        sum += manager.motivation_bonus;
						sum += manager.motivation_bonus_for_head ? manager.motivation_bonus_for_head : 0;
                    } else if (columnName === 'motivation_hand_bonus') {
                        sum += manager.motivation_hand_bonus;
                    } else if (columnName === 'motivation_hand_fines') {
                        sum += manager.motivation_hand_fines;
                    } else if (columnName != 'all') {
                        sum += manager.parameters[0][columnName];
                    } else {
                        sum += manager.motivation_bonus +
                                (manager.motivation_bonus_for_head ? manager.motivation_bonus_for_head : 0) +
                                manager.motivation_hand_fines +
								manager.motivation_hand_bonus;
                    }
                })

				sum = sum / nalogK;

                switch (columnName) {
                    default:
                        sum = formatter.format(sum) + ' р.'
                }


                return sum
            },
            formTableData() {
                this.visibleUsersDataForTable = this.scoredMotivation['items']
                this.visibleFieldsForTable = this.scoredMotivation['fields']
            },
            showMotivationByUserId(finance_ids, user_ids) {
                this.$emit("showMotivationByUserId", finance_ids, user_ids)
            },
            showHandMotivationByUserId(userId) {
                this.$emit("showHandMotivationByUserId", userId)
            },
            tdColorist(key) {
                switch (key) {
                    case 'user_name':
                        return 'td-light-gray '
                        break;
                    default:
                        return ''
                }
            },
            onlyForHeads() {
                if (this.currentUser.role && (this.currentUser.role.includes("administrator") ||
                    this.currentUser.role.includes("head-accountant") ||
                    this.currentUser.role.includes("accountant") ||
                    this.currentUser.role.includes("president"))) {
                    return true
                }
                return false
            },
            hasHistory () {
                return window.history.length > 2
            },
        }
    }
</script>
<style scoped>
    .table td.bg-green-light {
        background: #CCD3CF!important;
    }
    .table td.bg-danger-light{
        background: #ffb1b1!important;
    }
	.results-on-chart {
		width: 100%;
	}
	.small-label {
		font-size: 12px;
		line-height: 13px;
		margin-bottom: 10px;
		margin-top: -4px;
		max-width: 190px;
	}
</style>